module.exports = __webpack_public_path__ + "static/media/dabajianshan_web.dcc5839d.webp";